// ADR-0011: a failed spoken answer records which failure it was.

export type TranscriptionFailureReason = 'upload_failed' | 'transcription_failed' | 'no_speech';

export function classifyTranscriptionError(
  error: unknown,
  reachedServer: boolean,
): TranscriptionFailureReason {
  if (error === null) return 'no_speech';
  if (!reachedServer) return 'upload_failed';
  return 'transcription_failed';
}

/** A transcription failure that knows whether its upload ever reached the server. */
export class TranscriptionFailure extends Error {
  readonly reachedServer: boolean;
  /** A separate fact from the reason, not a fourth one — ADR-0011. */
  readonly unreadableAudio: boolean;

  constructor(
    message: string,
    reachedServer: boolean,
    options?: { cause?: unknown; unreadableAudio?: boolean },
  ) {
    super(message, options);
    this.name = 'TranscriptionFailure';
    this.reachedServer = reachedServer;
    this.unreadableAudio = options?.unreadableAudio ?? false;
  }
}

/** True only when the server named the clip itself as the problem — see ADR-0011. */
export function isUnreadableAudioFailure(error: unknown): boolean {
  return error instanceof TranscriptionFailure && error.unreadableAudio;
}

/** `undefined` when the failure carries no evidence — no default, by ADR-0011. */
export function classifyTranscriptionFailure(
  error: unknown,
): TranscriptionFailureReason | undefined {
  if (!(error instanceof TranscriptionFailure)) return undefined;
  return classifyTranscriptionError(error, error.reachedServer);
}
